import { connect } from "react-redux";
import { SliderSelect as Component } from "../SliderSelect";
import { dndqSetSequence, dndqSubmit } from "@learningblocks/exp-redux";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    updateSelection: (params) => {
      dispatch(dndqSetSequence(params));
    },
    submitAnswer: (id, type) => {
      dispatch(dndqSubmit(id, type));
    },
  };
}
export const SliderSelectRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
